import type { RepositoryError } from '@application/ports';

/**
 * El motivo que escribió el servidor, si el error es una respuesta suya.
 *
 * `translateCallableError` (en `infrastructure/repositories/support.ts`) deja
 * como `unavailable` tanto el rechazo con motivo —`invalid-argument`,
 * `failed-precondition`— como la petición que nunca llegó, y a ésta le antepone
 * el nombre de la callable. Lo segundo es «revisa tu conexión»; lo primero es una
 * frase escrita para quien la lee, y taparla con «revisa tu conexión» manda a
 * revisar el wifi a quien eligió un respaldo que está de vacaciones.
 */
export const serverAnswer = (error: RepositoryError, callable: string): string | null => {
  if (error.kind !== 'unavailable') return null;
  if (error.detail.startsWith(`${callable}: `)) return null;
  return error.detail.length > 0 ? error.detail : null;
};
